import React from 'react';
import { useTranslation } from 'react-i18next';
import './body-content.styles.scss';
import user_privacy from '../../../assest/home-card/User Privacy.svg';
import ecosystem from '../../../assest/home-card/trusted ecosystem (1).svg';
import customer from '../../../assest/home-card/Strong Customer Authentication (1).svg';

export const BodyContentCard = () => {
  const { t } = useTranslation();

  return (
    <div className='body-content'>
      <div className='body-content_text'>
        <p className='body-content_text-1'>{t('bodyContent.title')}</p>
        <p className='body-content_text-2'>{t('bodyContent.subtitle')}</p>
      </div>
      <div className='body-content_card'>
        <div className='body-content_card-1'>
          <img src={user_privacy} alt='body-card_icon' className='body-content_card-icon' />
          <p className='body-content_card-title'>{t('bodyContent.card1.title')}</p>
          <p className='body-content_card-desc text-center'>{t('bodyContent.card1.desc')}</p>
        </div>
        <div className='body-content_card-1'>
          <img src={ecosystem} alt='body-card_icon' className='body-content_card-icon' />
          <p className='body-content_card-title'>{t('bodyContent.card2.title')}</p>
          <p className='body-content_card-desc text-center'>{t('bodyContent.card2.desc')}</p>
        </div>
        <div className='body-content_card-1'>
          <img src={customer} alt='body-card_icon' className='body-content_card-icon' />
          <p className='body-content_card-title'>{t('bodyContent.card3.title')}</p>
          <p className='body-content_card-desc text-center'>{t('bodyContent.card3.desc')}</p>
        </div>
      </div>
    </div>
  );
};
